import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Analytics is now initialized via CookieConsent after user accepts

createRoot(document.getElementById("root")!).render(<App />);
